import { LogoRootstech, PersonGroup, ThingPresentation } from '@fs/zion-icon'

export const CHANNEL_TYPE = {
  FS_DIRECT: 'fs_direct',
  FS_MANAGED: 'fs_managed',
  FS_PUBLIC: 'fs_public',
  FS_ROOTSTECH: 'fs_rootstech',
  FS_SESSION: 'fs_session',
  FS_SUPPORT: 'fs_support',
  FS_THREAD: 'fs_thread',
  FS_VENDOR: 'fs_vendor',
  FS_HELPER_CONNECT: 'fs_helper_connect',
}

export const RESTRICTED_CATEGORY_MAP = {
  familySearchGroups: {
    key: CHANNEL_TYPE.FS_MANAGED,
    types: [CHANNEL_TYPE.FS_MANAGED],
  },
  threads: {
    key: CHANNEL_TYPE.FS_THREAD,
    types: [CHANNEL_TYPE.FS_THREAD],
  },
}

// Categories are used to group channels together in the UI. Some categories may contain multiple channel types
export const CHANNEL_CATEGORY_MAP = {
  privateChannels: {
    key: CHANNEL_TYPE.FS_DIRECT,
    types: [CHANNEL_TYPE.FS_DIRECT, CHANNEL_TYPE.FS_HELPER_CONNECT],
  },
  familySearchGroups: {
    key: CHANNEL_TYPE.FS_MANAGED,
    types: [CHANNEL_TYPE.FS_MANAGED],
  },
  attendeeCreatedChannels: {
    key: CHANNEL_TYPE.FS_PUBLIC,
    types: [CHANNEL_TYPE.FS_PUBLIC],
  },
  rootsTechChannels: {
    key: CHANNEL_TYPE.FS_ROOTSTECH,
    types: [CHANNEL_TYPE.FS_ROOTSTECH],
  },
  rootsTechSessionChannels: {
    key: CHANNEL_TYPE.FS_SESSION,
    types: [CHANNEL_TYPE.FS_SESSION],
  },
  askUsAnythingChannels: {
    key: CHANNEL_TYPE.FS_SUPPORT,
    types: [CHANNEL_TYPE.FS_SUPPORT],
  },
  threads: {
    key: CHANNEL_TYPE.FS_THREAD,
    types: [CHANNEL_TYPE.FS_THREAD],
  },
  vendorChannels: {
    key: CHANNEL_TYPE.FS_VENDOR,
    types: [CHANNEL_TYPE.FS_VENDOR],
  },
}
export const FS_THREAD_MESSAGE_PREFIX = 'tc:'

export const CHANNEL_TYPE_ICON = {
  [CHANNEL_TYPE.FS_SESSION]: ThingPresentation,
  [CHANNEL_TYPE.FS_ROOTSTECH]: LogoRootstech,
  [CHANNEL_TYPE.FS_PUBLIC]: PersonGroup,
}

export const CHAT_CREATE_EMPTY_TYPE = {
  DIRECT: 'empty-direct',
  GROUP: 'empty-group',
}

export const STATUS_CODE_CONFLICT = 409
export const MAX_LENGTH_MESSAGE = 5000
export const MESSAGE_HISTORY_START_INDEX = 100000
export const FS_DIRECT_MAX_PARTICIPANT_COUNT = 10
